import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';

import { AuditService, AuditLog } from '../../../core/services/audit.service';
import { PeruDatePipe } from '../../../shared/pipes/peru-date.pipe';

@Component({
  selector: 'app-audit-logs',
  standalone: true,
  imports: [
    CommonModule,
    PeruDatePipe,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    TagModule,
    SelectModule
  ],
  templateUrl: './audit-logs.html',
  styles: [`
    :host ::ng-deep .p-button-black {
      background: #000;
      border-color: #000;
      color: #fff;
      font-weight: 600;
    }
  `]
})
export class AuditLogsComponent implements OnInit {
  logs: AuditLog[] = [];
  loading = true;
  totalRecords = 0;
  rows = 15;

  search = '';
  selectedUsername: string | null = null;
  selectedAction: string | null = null;

  uniqueUsers: { label: string; value: string }[] = [];
  uniqueActions: { label: string; value: string }[] = [];

  private lastFirst = 0;

  constructor(
    private auditService: AuditService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadFilterOptions();
  }

  loadFilterOptions() {
    this.auditService.getFilterOptions().subscribe({
      next: (opts) => {
        this.uniqueUsers = (opts.usernames || []).map(u => ({ label: u, value: u }));
        this.uniqueActions = (opts.actions || []).map(a => ({ label: a, value: a }));
        this.cdr.detectChanges();
      },
      error: () => this.cdr.detectChanges()
    });
  }

  loadLogs(event?: TableLazyLoadEvent) {
    this.loading = true;
    const first = event?.first ?? this.lastFirst;
    const rows = event?.rows ?? this.rows;
    this.lastFirst = first;
    this.rows = rows;
    const page = rows > 0 ? Math.floor(first / rows) : 0;

    this.auditService.getLogs(page, rows, {
      search: this.search?.trim() || undefined,
      username: this.selectedUsername || undefined,
      action: this.selectedAction || undefined
    }).subscribe({
      next: (res) => {
        this.logs = (res.content || []).map(log => ({
          ...log,
          dateObj: new Date(log.timestamp)
        }));
        this.totalRecords = res.totalElements || 0;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (e) => {
        console.error(e);
        this.logs = [];
        this.totalRecords = 0;
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  onSearch() {
    this.lastFirst = 0;
    this.loadLogs({ first: 0, rows: this.rows });
  }

  clear() {
    this.search = '';
    this.selectedUsername = null;
    this.selectedAction = null;
    this.onSearch();
  }

  getActionSeverity(action: string): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined {
    if (!action) return 'secondary';
    if (action.includes('CREATE') || action.includes('REGISTER') || action.includes('ADD') || action.includes('INVITAR')) return 'success';
    if (action.includes('UPDATE') || action.includes('EDIT') || action.includes('CHANGE')) return 'info';
    if (action.includes('DELETE') || action.includes('REMOVE') || action.includes('DEACTIVATE')) return 'danger';
    if (action.includes('LOGIN') || action.includes('VERIFY')) return 'warn';
    return 'secondary';
  }
}
